import { JitsiConferenceErrors, JitsiConferenceEvents } from '../../../../react/features/base/lib-jitsi-meet';
import { MEDIA_TYPE } from '../../../../react/features/base/media/constants';
import { getLocalParticipant } from '../../../../react/features/base/participants/functions';
import { DEFAULT_SERVER_URL } from '../../../../react/features/base/settings/constants';
import { getLocalJitsiAudioTrack, getLocalTrack, getLocalVideoTrack } from '../../../../react/features/base/tracks/functions.any';
import statsEmitter from '../../../../react/features/connection-indicator/statsEmitter';
import { isScreenVideoShared } from '../../../../react/features/screen-share/functions';
import { shouldDisplayTileView } from '../../../../react/features/video-layout/functions.any';
import { iAmVisitor } from '../../../../react/features/visitors/functions';
import { getLocalParticipantPropertyByTagName, getStorageData, getUTCTimestamp } from '../../../functions.any';
import { sendConferenceJoinedEvent } from '../actions';
import { getLocalAudioTrackData, getLocalVideoTrackData } from '../functions';
import { onConnectionStatsUpdate, saveDisconnectInfo, sendStatsDisconnectedRoom } from './actions';
export function sendFetchData(obj) {
    // @ts-ignore
    const baseUrl = navigator.product === 'ReactNative' ? `${DEFAULT_SERVER_URL}/` : config.baseUrl;
    const fetchUrl = `${baseUrl}api/log/wizyconf`;
    const headers = {
        'Content-Type': 'application/json'
    };
    return fetch(fetchUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(obj)
    });
}
const createClientStatsHandler = (dispatch, participantID) => {
    const onConnectionStatsRun = (props) => {
        dispatch(onConnectionStatsUpdate(props));
    };
    const subscribeToClientStats = (statsEmitter) => {
        statsEmitter.subscribeToClientStats(participantID, onConnectionStatsRun);
    };
    const unsubscribeFromClientStats = (statsEmitter) => {
        statsEmitter.unsubscribeToClientStats(participantID, onConnectionStatsRun);
    };
    return { subscribeToClientStats,
        unsubscribeFromClientStats };
};
export function conferenceFailed({ dispatch }, action, next) {
    const { error } = action;
    if (error.name === JitsiConferenceErrors.ICE_FAILED
        || error.name === JitsiConferenceErrors.VIDEOBRIDGE_NOT_AVAILABLE) {
        dispatch(saveDisconnectInfo(error.name));
    }
    return next(action);
}
export function conferenceDispose({ dispatch, getState }, action, next) {
    const state = getState();
    const { unsubscribeFromClientStats } = createClientStatsHandler(dispatch, localParticipantID(state));
    unsubscribeFromClientStats(statsEmitter);
    return next(action);
}
export function conferenceJoined({ dispatch, getState }, action, next) {
    const result = next(action);
    const state = getState();
    const { subscribeToClientStats } = createClientStatsHandler(dispatch, localParticipantID(state));
    subscribeToClientStats(statsEmitter);
    dispatch(sendStatsDisconnectedRoom());
    dispatch(sendConferenceJoinedEvent());
    return result;
}
export function localParticipantID(state) {
    return getLocalParticipant(state)?.id ?? '';
}
export function _bindConferenceConnectionListener(conference, { dispatch }) {
    conference.on(JitsiConferenceEvents.CONNECTION_INTERRUPTED, () => {
        dispatch(saveDisconnectInfo(JitsiConferenceEvents.CONNECTION_INTERRUPTED));
    });
}
export function getRoomToken(state) {
    // @ts-ignore
    const conference = state()['features/base/conference'];
    return conference?.room ?? conference?.conference?.getName() ?? '';
}
export function getDisconnectInfo(getState) {
    return JSON.parse(getStorageData(`disconnectInfo_${getRoomToken(getState)}`) || '{}');
}
export function getSharingVariant(state) {
    const localVideo = getLocalVideoTrack(state['features/base/tracks']);
    if (!localVideo) {
        return;
    }
    // track label format depends on client browser
    // for Chrome:
    //   web-contents-media-stream:<first_id>:<second_id> - tab
    //   screen:<first_id>:<second_id> - entire screen
    //   window:<first_id>:<second_id> - app window
    // for Safari:
    //   Screen <screen_number> - entire screen
    // for FF:
    //   name of app or Entire Screen
    const trackLabel = localVideo.jitsiTrack.getTrackLabel();
    const variant = trackLabel.replace(/:.*/, '');
    if (variant === 'web-contents-media-stream') {
        return 'tab';
    }
    return variant;
}
export function getUserDataFromPresence(conference) {
    try {
        const room = conference?.room;
        // @ts-ignore
        const xmpp = conference?.xmpp;
        const displayName = getLocalParticipantPropertyByTagName(room, 'displayName') || '';
        const email = getLocalParticipantPropertyByTagName(room, 'email') || '';
        const ctijid = getLocalParticipantPropertyByTagName(room, 'ctijid') || '';
        const ctiextension = getLocalParticipantPropertyByTagName(room, 'ctiextension') || '';
        const websocketUser = xmpp?.myJid() ? xmpp.myJid().split('@')[0] : '';
        return {
            displayName,
            email,
            ctijid,
            ctiextension,
            websocketUser,
            userId: conference?.myUserId() || '',
            room: conference?.getName() || ''
        };
    }
    catch (error) {
        console.warn('Error in getUserDataFromPresence:', error);
        return {
            displayName: '',
            email: '',
            ctijid: '',
            ctiextension: '',
            websocketUser: '',
            userId: '',
            room: ''
        };
    }
}
export function buildBaseStats(state, stats) {
    const audioJitsiTrack = getLocalJitsiAudioTrack(state);
    const { preferredVideoQuality } = state['features/video-quality'];
    const { enabled: audioOnly } = state['features/base/audio-only'];
    const localVideoTrack = getLocalTrack(state['features/base/tracks'], MEDIA_TYPE.VIDEO);
    const localScreenSharingTrack = getLocalTrack(state['features/base/tracks'], MEDIA_TYPE.SCREENSHARE);
    const videoTrackData = localVideoTrack ? getLocalVideoTrackData(localVideoTrack, state) : {};
    const screenshareTrackData = localScreenSharingTrack ? getLocalVideoTrackData(localScreenSharingTrack, state) : {};
    const { getMosData } = state['features/base/conference'].conference ?? {};
    return {
        ...stats,
        videoTrackData,
        screenshareTrackData,
        audioTrack: getLocalAudioTrackData(audioJitsiTrack),
        isVisitor: iAmVisitor(state),
        preferredVideoQuality,
        audioOnly,
        MOSData: getMosData?.(),
        isScreenVideoShared: Boolean(isScreenVideoShared(state)),
        tileViewEnabled: shouldDisplayTileView(state),
        clientTimestamp: getUTCTimestamp()
    };
}
export function removeMediaFieldsFromStats(originalObject) {
    const rest = { ...originalObject };
    // Delete fields from stats object
    delete rest.framerate;
    delete rest.codec;
    delete rest.resolution;
    return rest;
}
export function isKibanaLogsEnabled(state) {
    const { enableKibanaLogs } = state['features/base/config'] ?? {};
    return Boolean(enableKibanaLogs);
}
